<div class="font-bold  md:text-xl mb-2">{{title}}</div>
<div [innerHTML]="content" class="font-normal  md:text-lg leading-6 md:leading-10 "></div>